import {
  deepOrange,
  deepPurple,
  red,
  pink,
  purple,
  indigo,
  blue,
  teal,
  green,
  brown,
  grey,
} from "@mui/material/colors";

export const GenerateRandomBackgroundColor = () => {
  const darkColors = [
    deepOrange[900], // Dark deepOrange
    deepPurple[900], // Dark deepPurple
    red[900], // Dark red
    pink[900], // Dark pink
    purple[900], // Dark purple
    indigo[900], // Dark indigo
    blue[900], // Dark blue
    teal[900], // Dark teal
    green[900], // Dark green
    brown[900], // Dark brown
    grey[900], // Dark grey
    // You can add more dark colors here as needed
  ];
  const randomIndex = Math.floor(Math.random() * darkColors.length);
  return darkColors[randomIndex];
};
